export default "__VITE_ASSET__BeQQrZpR__"